import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

const RegisterPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>()
  const [formData, setFormData] = useState({
    parentName: '',
    email: '',
    mobile: '',
    nokName: '',
    nokMobile: '',
    numChildren: 1,
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      const response = await fetch('/api/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          eventSlug: slug,
          ...formData,
        }),
      })

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.message || 'Registration failed')
      }

      setSuccess(true)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Registration failed')
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  if (success) {
    return (
      <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
        <div className="alert alert-success mb-4">
          <h2>Registration Successful!</h2>
          <p>You will receive a confirmation email with your registration number shortly.</p>
        </div>
        <p className="mb-4">
          Please use the registration number provided in the email to label your children at the event.
        </p>
        <p className="text-sm text-gray-600">
          Keep this registration number safe - ASF staff will use it to contact you if needed.
        </p>
      </div>
    )
  }

  return (
    <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h1 className="mb-8 text-center">Event Registration</h1>
      
      {error && (
        <div className="alert alert-error mb-4">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="parentName" className="form-label">
            Parent/Guardian Name *
          </label>
          <input
            type="text"
            id="parentName"
            name="parentName"
            className="form-input"
            value={formData.parentName}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="email" className="form-label">
            Email Address *
          </label>
          <input
            type="email"
            id="email"
            name="email"
            className="form-input"
            value={formData.email}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="mobile" className="form-label">
            Mobile Number *
          </label>
          <input
            type="tel"
            id="mobile"
            name="mobile"
            className="form-input"
            value={formData.mobile}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="numChildren" className="form-label">
            Number of Children *
          </label>
          <input
            type="number"
            id="numChildren"
            name="numChildren"
            className="form-input"
            value={formData.numChildren}
            onChange={handleChange}
            min="1"
            max="10"
            required
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="nokName" className="form-label">
            Next of Kin Name (Optional)
          </label>
          <input
            type="text"
            id="nokName"
            name="nokName"
            className="form-input"
            value={formData.nokName}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="nokMobile" className="form-label">
            Next of Kin Mobile (Optional)
          </label>
          <input
            type="tel"
            id="nokMobile"
            name="nokMobile"
            className="form-input"
            value={formData.nokMobile}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        <button 
          type="submit" 
          className="btn btn-primary"
          disabled={loading}
          style={{ width: '100%' }}
        >
          {loading ? <span className="spinner" /> : 'Register'}
        </button>
      </form>
    </div>
  )
}

export default RegisterPage
